import {
  IResult,
  IDrawOverlaysDelete,
  IDrawOverlayParameter,
  IFindParameter,
  IPolylineRangingParameter
} from "@/types/map";

declare let ol: any;
export default class PolylineRangingPGIS {
  private static instances: Map<string, any>;
  private view: any;
  private fmap: any;
  private rangingLayers: any[] = [];
  private drawManager: any;
  //测量辅助提示框
  private helpTooltipElement!: any;
  private helpTooltip: any;
  //测量数据显示框
  private measureTooltipElement!: any;
  private measureTooltip: any;
  private ptMoveEvt: any;
  private ptMoveOutEvt: any;
  private tooltips: any[] = [];

  private constructor(view: any, fmap: any) {
    this.view = view;
    this.fmap = fmap;
  }

  public static getInstance(view: any, fmap: any) {
    let id = view.getTarget();
    if (!PolylineRangingPGIS.instances) {
      PolylineRangingPGIS.instances = new Map();
    }
    let instance = PolylineRangingPGIS.instances.get(id);
    if (!instance) {
      instance = new PolylineRangingPGIS(view, fmap);
      PolylineRangingPGIS.instances.set(id, instance);
    }
    return instance;
  }

  private async createOverlayLayer(): Promise<any> {
    const layerStyle = new ol.style.Style({
      fill: new ol.style.Fill({
        color: "rgba(255, 255, 255, 0.2)"
      }),
      stroke: new ol.style.Stroke({
        color: "#33ffe0",
        width: 2
      }),
      image: new ol.style.Circle({
        radius: 7,
        fill: new ol.style.Fill({
          color: "#33ffe7"
        })
      })
    });
    //存储原始矢量点、线、面
    const vectorLayer = new ol.layer.Vector({
      source: new ol.source.Vector({}),
      style: layerStyle
    });
    vectorLayer.title = "polylineRanging_layer";
    this.view.addLayer(vectorLayer);
    this.rangingLayers.push(vectorLayer);
    return vectorLayer;
  }

  public async polylineRanging(
    params: IPolylineRangingParameter
  ): Promise<IResult> {
    await this.stopPolylineRanging();
    let type = params ? params.type || "LineString" : "LineString"; //"LineString","Polygon"
    type = type.replace("line", "LineString").replace("area", "Polygon");
    let rangingLayer = await this.createOverlayLayer();
    const draw = new ol.interaction.Draw({
      source: rangingLayer.getSource(),
      type: type,
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: "rgba(255,255,255,0.2)"
        }),
        stroke: new ol.style.Stroke({
          color: "#33ffe0",
          lineDash: [10, 10],
          width: 2
        }),
        image: new ol.style.Circle({
          radius: 5,
          stroke: new ol.style.Stroke({
            color: "#33ffe0"
          }),
          fill: new ol.style.Fill({
            color: "rgba(255,255,255,0.2)"
          })
        })
      })
    });
    this.drawManager = draw;
    this.view.addInteraction(this.drawManager);

    await this.creatHelpTooltip();

    let listener: any;
    let that = this;

    let sketch: any;
    this.ptMoveEvt = this.view.on("pointermove", function(evt: any) {
      //如果是平移地图则直接结束
      if (evt.dragging) {
        return;
      }
      //帮助提示信息
      let helpMsg = "单击开始测距";
      //设置帮助提示信息的位置
      if (that.helpTooltip) {
        that.helpTooltip.setPosition(evt.coordinate);
      }

      if (sketch) {
        helpMsg = "单击继续测距，双击结束测距";
      }
      //设置帮助提示要素的内标签为帮助提示信息
      if (that.helpTooltipElement) {
        that.helpTooltipElement.innerHTML = helpMsg;
      }
      that.helpTooltipElement.classList.remove("hidden");
    });
    // //处理鼠标移出地图事件
    // this.view.getViewport().addEventListener('mouseout', this.hideHelpTooltipEle.bind(this));

    draw.on("drawstart", async (startEvt: any) => {
      await that.createMeasureTooltip();
      sketch = startEvt.feature;
      let tooltipCoordinate = startEvt.coordinate;

      listener = sketch
        .getGeometry()
        .on("change", async function(changeEvt: any) {
          let output;
          const geom = changeEvt.target;
          if (geom instanceof ol.geom.Polygon) {
            //输出多边形的面积
            output = await that.formatArea(geom);
            //Return an interior point of the polygon.
            //获取多变形内部点的坐标
            tooltipCoordinate = geom.getInteriorPoint().getCoordinates();
          } else if (geom instanceof ol.geom.LineString) {
            //输出多线段的长度
            output = await that.formatLength(geom);
            //Return the last coordinate of the geometry.
            //获取多线段的最后一个点的坐标
            tooltipCoordinate = geom.getLastCoordinate();
          }

          if (that.measureTooltipElement) {
            that.measureTooltipElement.innerHTML = output;
          }
          if (that.measureTooltip) {
            that.measureTooltip.setPosition(tooltipCoordinate);
          }
        });
    });

    draw.on("drawend", async function(drawEndEvt: any) {
      // clickCount = 0;
      //设置测量提示框的样式
      that.measureTooltipElement.className = "ol-tooltip ol-tooltip-static";
      // that.measureTooltipElement.setAttribute('background-color', '#ffcc33')
      //Set the offset for this overlay.
      //设置偏移量
      that.measureTooltip.setOffset([0, -7]);
      //清空绘制要素
      sketch = null;
      //清空测量提示要素
      that.measureTooltipElement = null;
      that.measureTooltip = null;
      ol.Observable.unByKey(listener);

      that.stopPolylineRanging();
    });

    return {
      status: 0,
      message: "成功调用polylineRanging方法！"
    };
  }

  public async stopPolylineRanging(): Promise<IResult> {
    if (this.drawManager instanceof ol.interaction.Draw) {
      this.drawManager.finishDrawing();
      this.view.removeInteraction(this.drawManager);
      this.drawManager = null;
    }

    if (this.ptMoveEvt) {
      ol.Observable.unByKey(this.ptMoveEvt);
      this.ptMoveEvt = null;
    }

    if (this.helpTooltip) {
      this.view.removeOverlay(this.helpTooltip);
      this.helpTooltip = null;
      this.helpTooltipElement = null;
    }

    if (this.measureTooltip) {
      this.view.removeOverlay(this.helpTooltip);
      this.measureTooltip = null;
      this.measureTooltipElement = null;
    }

    return {
      status: 0,
      message: "成功调用stopPolylineRanging方法！"
    };
  }

  public async clearRangingResults(): Promise<IResult> {
    await this.stopPolylineRanging();
    this.rangingLayers.forEach((layer) => {
      if (layer instanceof ol.layer.Vector) {
        this.view.removeLayer(layer);
      }
    }, this);

    this.rangingLayers = [];

    for (let tooltip of this.tooltips) {
      this.view.removeOverlay(tooltip);
    }
    return {
      status: 0,
      message: "成功调用clearRangingResults方法！"
    };
  }

  private async creatHelpTooltip() {
    //如果已经存在帮助提示框则移除
    if (this.helpTooltipElement) {
      this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
    }
    //创建帮助提示要素的div
    if (!this.helpTooltipElement)
      this.helpTooltipElement = document.createElement("div");
    //设置帮助提示要素的样式
    this.helpTooltipElement.className = "ol-tooltip hidden";
    //创建一个帮助提示的覆盖标注
    // if(this.helpTooltip instanceof ol.Overlay){
    //   this.view.removeOverlay(this.helpTooltip);
    //   this.helpTooltip = null;
    // }
    this.helpTooltip = new ol.Overlay({
      element: this.helpTooltipElement,
      offset: [15, 0],
      positioning: "center-left"
    });
    //将帮助提示的覆盖标注添加到地图中
    this.view.addOverlay(this.helpTooltip);
  }

  private async createMeasureTooltip() {
    if (this.measureTooltipElement) {
      this.measureTooltipElement.parentNode.removeChild(
        this.measureTooltipElement
      );
    }

    this.measureTooltipElement = document.createElement("div");
    this.measureTooltipElement.className = "ol-tooltip ol-tooltip-measure";

    this.measureTooltip = new ol.Overlay({
      element: this.measureTooltipElement,
      offset: [0, -15],
      positioning: "bottom-center"
    });
    //将测量提示的覆盖标注添加到地图中
    this.view.addOverlay(this.measureTooltip);
    this.tooltips.push(this.measureTooltip);
  }

  private async formatLength(line: any) {
    console.log(line);
    //定义长度变量
    let length;
    //计算平面距离
    length =
      Math.round(
        ol.sphere.getLength(line, {
          projection: "EPSG:4326"
        }) * 100
      ) / 100;
    //定义输出变量
    var output;
    //如果长度大于1000，则使用km单位，否则使用m单位
    if (length > 100) {
      output = Math.round((length / 1000) * 100) / 100 + " " + "km"; //换算成KM单位
    } else {
      output = Math.round(length * 100) / 100 + " " + "m"; //m为单位
    }
    return output;
  }
  //格式化测量面积
  private async formatArea(polygon: any) {
    //定义面积变量
    var area;
    //获取平面面积
    area = ol.sphere.getArea(polygon, {
      projection: "EPSG:4326"
    });
    // }
    //定义输出变量
    var output;
    //当面积大于10000时，转换为平方千米，否则为平方米
    if (area > 1000) {
      output =
        Math.round((area / 1000000) * 100) / 100 + " " + "km<sup>2</sup>";
    } else {
      output = Math.round(area * 100) / 100 + " " + "m<sup>2</sup>";
    }
    return output;
  }
  private hideHelpTooltipEle() {
    this.helpTooltipElement.classList.add("hidden");
  }
}
